import { useMemo, useState } from 'react'

import { Button, DefaultDropdownMenu, FormGroup, Label as FormLabel, InputGroup, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue, SelectWrapper } from 'twyne-new.ui'

import { useStoreTemplates } from '@/modules/cms/views/post/components/builder/context'

export default function SelectTemplate({ onAddTemplate, open, onClose }) {
  const handleAdd = template => {
    onClose()
    onAddTemplate(template)
  }

  return <>
    <DefaultDropdownMenu
      wrapperProps={{ open, onOpenChange: onClose, defaultOpen: open, modal: true }}
      contentProps={{ className: 'w-60', align: 'center' }}
    >
      <FormGroup>
        <FormLabel>Select Template</FormLabel>
        <SelectTemplateGroup onAdd={handleAdd} />
      </FormGroup>
      <FormGroup>
      </FormGroup>
    </DefaultDropdownMenu>
  </>
}

function SelectTemplateGroup({ onAdd }) {
  const { items } = useStoreTemplates()
  const [selected, setSelected] = useState()

  const options = useMemo(() => items.map(item => ({ label: item.name, value: item.id, data: item })), [items])

  return <InputGroup variant='accent'>
    <SelectWrapper onValueChange={setSelected} defaultValue={selected}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent container='#theme-provider' position={'popper'}>
        <SelectGroup>
          {options.map(option => <SelectItem
            key={option.value}
            value={option}
          >
            {option.label}
          </SelectItem>)}
        </SelectGroup>
      </SelectContent>
    </SelectWrapper>
    <Button color='accent' onClick={() => onAdd(selected.data)}>
      Add
    </Button>
  </InputGroup>
}
